import LocationEpisode, { LocationEpisodeOptions } from 'models/LocationEpisode';
import http from 'services/http';

type CreateParams = {
  locationEpisodeId: string;
  states: {
    apiName: string;
    enteredAt: string;
  }[];
};
export async function createDateChanges(params: CreateParams) {
  return http
    .post<LocationEpisodeOptions>(`/location_episodes/${params.locationEpisodeId}/date_changes`, params)
    .then((res) => new LocationEpisode(res.data));
}
